//live
export const APIBASE = "https://api.lcardapp.com";

export const baseDomain = "https://lcardapp.com/";

export const PublicCardBase = "https://share.lcardapp.com/";

// //staging
// export const baseDomain = "https://lcards.newagesmb.com/";

// export const APIBASE = "https://api-lcard.newagesmb.com/";

// export const PublicCardBase = "https://lcardshare.newagesmb.com/";
